<template>
  <v-card flat>
    <!-- <ModelTitle :title="addStudentLabel()"  /> -->
    <v-toolbar color="primary" flat tile dark>
      <v-toolbar-title>Add Student</v-toolbar-title>
      <!-- <v-toolbar-title>{{ addSelectedStudent.length }} Selected</v-toolbar-title> -->
      <v-spacer></v-spacer>

      <v-btn icon @click="backToHome">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-autocomplete dense autofocus hide-details :items="AllStudents" clearable item-text="fullName"
            v-model="selectedStudent" return-object label="Select Student" outlined><template slot="item"
              slot-scope="{ item }">
              <span>{{ item.fullName }}</span>
              <v-spacer></v-spacer>
              <v-chip color="grey lighten-3">
                <v-avatar left class="grey lighten-2">
                  <v-icon small>mdi-google-classroom</v-icon>
                </v-avatar>
                <span>{{ item.classCount }}</span>
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text> -->

    <v-container grid-list-lg v-if="selectedClassRoom">
      <v-layout row>
        <v-flex xs12>
          <div>
            Room Name:
            <span class="font-weight-bold text-capitalize">{{
                selectedClassRoom.ClassRoom.name
            }}</span>
          </div>
        </v-flex>
        <v-flex v-if="AllStudents.length">
          <v-autocomplete dense autofocus hide-details :items="AllStudents" clearable item-text="fullName"
            v-model="selectedStudent" return-object label="Select Student" outlined>

            <template slot="item" slot-scope="{ item }">
              <v-list-item-content>
                <v-list-item-title class="text--primary text-capitalize" v-text="item.fullName">
                </v-list-item-title>

                <v-list-item-subtitle class="caption" v-if="!item.ClassRoomStudents.length">
                  <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                    Not Assign To Any Class
                  </v-chip>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="caption" v-if="item.ClassStudents.length"
                  v-text="item.ClassStudents[0].Class.name">
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action-text
                v-if="item.ClassRoomStudents.length > 0 && item.ClassRoomStudents[0].ClassRoom.name">
                <v-list-item-title class="text--primary text-capitalize"
                  v-text="item.ClassRoomStudents[0].ClassRoom.name">
                </v-list-item-title>
              </v-list-item-action-text>


            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex shrink>
          <v-btn @click="submit" :disabled="!selectedStudent" color="success">Add</v-btn>
        </v-flex>
      </v-layout>
    </v-container>



    <v-card-text>

      <v-list class="addStdList">
        <template v-for="(row, index) in StudentsInThisClass">
          <v-list-item :key="index" v-if="row.Student">
            <v-list-item-avatar>
              <v-btn icon>
                <v-icon color="red" @click="deleteRow(row)">delete</v-icon>
              </v-btn>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-capitalize" >{{
                  row.Student.fullName
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>


    <!-- <v-card-text>
      <v-text-field v-model="search" autofocus outlined prepend-inner-icon="search" rounded dense label="Search"
        single-line hide-details clearable></v-text-field>
      <v-list two-line class="addStdList">
        <v-list-item-group v-model="addSelectedStudent" active-class="green--text" multiple>
          <template v-for="(item, index) in resultQuery">
            <v-list-item :key="item.createdAt" :value="item">
              <template  v-slot:default="{ active }">
                <v-list-item-content>
                  <v-list-item-title class="text--primary text-capitalize" v-text="item.fullName">
                  </v-list-item-title>



                  <v-list-item-subtitle class="caption" v-if="item.ClassRoomStudents.length"
                    v-text="item.ClassRoomStudents[0].ClassRoom.name"></v-list-item-subtitle>
                  <v-list-item-subtitle class="caption" v-else>
                    <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                      Not Assign To Any Class
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="caption" v-if="item.ClassStudents.length"
                    v-text="item.ClassStudents[0].Class.name">
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-checkbox :input-value="active" color="green accent-4"></v-checkbox>
                </v-list-item-action>

              </template>
            </v-list-item>

            <v-divider v-if="index < resultQuery.length - 1" :key="index"></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card-text> -->

    <!-- <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-if="addSelectedStudent.length" text @click="addSelectedStudent = []">
        Clear All
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" :disabled="addSelectedStudent.length ? false : true" @click="bringStudent">
        Add To Class
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import studentService from '@/modules/Student/service.js'
// import teacherService from "@/modules/Teacher/service.js";
import classRoomService from "@/modules/ClassRoom/service.js";
// 
export default {
  name: 'add-student-to-class',
  data() {
    return {
      selectedStudent: null,
      AllStudents: [],
      StudentsInThisClass: [],
      addSelectedStudent: [],
      Teacher: null,
      selectedClassRoom: null,
    }
  },
  created() {
    console.log('this.$route.params', this.$route.params)
    if (Object.keys(this.$route.params).length === 0) {
      this.$router.push({ name: 'thome' })

    } else {
      this.Teacher = this.$route.params.teacher
      this.selectedClassRoom = this.$route.params.selectedClassRoom
      this.StudentsInThisClass = this.$route.params.students
      console.log('this.student', this.Students)

      this.getAllStudent()
    }
  },
  computed: {
    resultQuery() {
      if (this.search) {
        return this.AllStudents.filter((item) => {
          return this.search.toLowerCase().split(' ').every(v => item.fullName.toLowerCase().includes(v))
        })
      } else {
        return this.AllStudents;
      }

    },
  },
  methods: {
    deleteRow(row) {
      console.log("row", row);
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${row.Student.fullName} from your class`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          classRoomService
            .removeStudent(row.id)
            .then((response) => {
              if (response.data) {
                const studentId = (element) => element.id === row.id;

                let i = this.StudentsInThisClass.findIndex(studentId);
                this.StudentsInThisClass.splice(i, 1);
                this.$swal(
                  "Remove!",
                  "Student has been remove from this teacher.",
                  "success"
                );
                // this.getList();
              }
            });
        }
      });
    },
    async submit() {
      console.log('studne', this.selectedStudent)
      if (this.selectedStudent.ClassRoomStudents.length > 0) {
        this.$swal({
          title: "Are you sure?",
          text: `You are taking student from ${this.selectedStudent.ClassRoomStudents[0].ClassRoom.name} to your class.`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          console.log('result', result)
          if (result.value) {
            let obj = {
              ClassRoomId: this.selectedClassRoom.ClassRoomId,
              StudentId: this.selectedStudent.id,
            };
            classRoomService
              .assignStudent(obj)
              .then((result) => {
                console.log('result', result)
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  .fire({
                    icon: "success",
                    title: "Student was assist to class",
                  });

                this.StudentsInThisClass.push(result.data);
                // this.empty();
                // this.$emit("submit");
              })
              .catch((err) => {
                console.log('err', err)
                this.loading = false;
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  .fire({
                    icon: "error",
                    title: err.data.message,
                  });
              });

            this.selectedStudent = null;
          }
        });
      } else {
        let obj = {
          ClassRoomId: this.selectedClassRoom.ClassRoomId,
          StudentId: this.selectedStudent.id,
        };
        classRoomService
          .assignStudent(obj)
          .then((result) => {
            console.log('result', result)
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Student was assist to class",
              });

            this.StudentsInThisClass.push(result.data);
            // this.empty();
            // this.$emit("submit");
          })
          .catch((err) => {
            console.log('err', err)
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });

        this.selectedStudent = null;
      }


    },
    async bringStudent() {
      console.log('bringStudent', this.addSelectedStudent, this.Teacher)
      await Promise.all(this.addSelectedStudent.map(async (student) => {
        console.log('student', student)
        if (student.ClassRoomStudents.length) {
          try {
            const newDate = {
              ClassRoomId: this.selectedClassRoom.ClassRoomId
            }
            const studentMove = await classRoomService.updateClassStudent(student.ClassRoomStudents[0].id, newDate)

            console.log('studentMove', newDate, studentMove)
          } catch (error) {
            console.log('error', error)

          }
        } else {
          console.log('didnot have teacher')
          try {
            const newDate = {
              ClassRoomId: this.selectedClassRoom.ClassRoomId,
              StudentId: student.id
            }
            const studentMove = await classRoomService.assignStudent(newDate)
            console.log('studentMove', studentMove)
          } catch (error) {
            console.log('error', error)

          }
        }

        // await studentService.updateStudentTeacher(this.addSelectedStudent.id, )
      }))

      this.backToHome()

      // this.dialog = !this.dialog
      // this.getTeacher()
    },
    backToHome() {
      this.$router.push({ name: 'thome' })
    },
    // addStudentLabel() {
    //   let label = 'Add Student'
    //   if (this.addSelectedStudent.length !== 0) {
    //     label = this.addSelectedStudent.length + ' Student Selected'
    //   }

    //   return label
    // },
    getAllStudent() {
      studentService.getAll({ ClassId: this.selectedClassRoom.ClassRoom.ClassId }).then(async (result) => {
        console.log('result', result.data)
        this.AllStudents = result.data
        this.StudentsInThisClass.map(classRoomStudent => {
          // console.log('classRoomStudent', classRoomStudent)
          const sameId = (student) => {
            // console.log('v', student.id, classRoomStudent.StudentId)
            return student.id === classRoomStudent.StudentId
          };
          // console.log('sameId', sameId)
          // console.log(this.AllStudents.findIndex(sameId));
          this.AllStudents.splice(this.AllStudents.findIndex(sameId), 1);
        })

        // const isLargeNumber = (element) => element > 13;

        // console.log(array1.findIndex(isLargeNumber));

        // await Promise.all(this.AllStudents.map(async (student, index) => {
        //   await Promise.all(this.StudentsInThisClass.map(classRoomStudent => {
        //     // console.log('classRoomStudent', classRoomStudent.StudentId)
        //     if (student.id === classRoomStudent.StudentId) {
        //       // console.log('found it', student.id, classRoomStudent.StudentId )
        //       this.AllStudents.splice(index, 1);
        //     }
        //   }))

        // }))

      })
    }
  }
}
</script>

<style scoped>
.addStdList {
  height: calc(100vh - 250px);
  overflow: auto;
}
</style>